import makeSlice from '@web/slices/card/sliceMaker'

const slice = makeSlice()

export default slice.reducer
